import React from 'react'
import PropTypes from 'prop-types'
import InlineLoader from '../InlineLoader/InlineLoader'
import styled, { withTheme } from 'styled-components'

const Wrapper = styled.div`
  a {
    color: var(--white);
  }
  position: relative;
  margin-bottom: 25px;
  .mini-vid-frame {
    margin-top: 0px;
    margin-bottom: 15px;
  }
  .child {
    width: 90%;
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50% -50%);
  }
  .parent {
    height: 100px;
    font-size: 17px;
    position: relative;
    border-top: 2px solid;
    border-color: var(--clr-accent-to-black);
    float: none !important;
    display: block !important;
    text-align: center;
  }
  border: 2px solid;
  border-color: var(--clr-accent-to-black);
  margin-top: -15px;
  min-height: 300px;
  text-align: center;

  @media (max-width: 480px) {
    display: none;
  }
`

const NavColumnContent = ({ content }) => {
  const styles = {
    position: 'absolute',
    left: '90%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  }

  if (Object.keys(content).length === 0) {
    return <InlineLoader style={styles} />
  } else {
    return (
      <div>
        {content.header}
        {content.links}
      </div>
    )
  }
}

const NavColumn = ({ content }) => {
  return (
    <Wrapper>
      <div className="nav-column">
        <NavColumnContent content={content} />
      </div>
    </Wrapper>
  )
}

NavColumn.propTypes = {
  content: PropTypes.object.isRequired
}

export default withTheme(NavColumn)



// WEBPACK FOOTER //
// ./src/components/NavColumn/NavColumn.js